import EditAisleCardSettingsAction from './EditAisleCardSettingsAction'

export default {
  install( molten ) {
    molten.addPlugin( 'Action', EditAisleCardSettingsAction )
  }
}
